<template>
  <div class="panel_settlement">
    <div style="padding-top: 7px">
      <span class="priceItem">
        <span class="label">总计：</span>
        <span class="price">￥{{ money }}</span>
      </span>
      <span class="priceItem">
        <span class="label">优惠：</span>
        <span class="price">￥{{ $public.jian(money, activityMoney) }}</span>
      </span>
      <span
        class="priceItem"
        style="font-size: 12px"
        v-if="curDiscountCard && curDiscountCard._id"
      >
        {{ curDiscountCard.coupon_name }}({{
          $public.getDiscountType(curDiscountCard.apply_range.order_type)
        }}券)
        <span v-if="curDiscountCard.activity_type === 1">
          满{{ curDiscountCard.money_top }}元可用
        </span>
        <span v-if="curDiscountCard.activity_type === 2">
          满{{ curDiscountCard.rebate_top }}元可用，
          <span v-if="curDiscountCard.rebate_limit > 0"
            >最高抵扣{{ curDiscountCard.rebate_limit }}元</span
          >
          <span v-else></span>
        </span>
        <span style="color: #1890ff; cursor: pointer" @click="delDiscountCard"
          >删除</span
        >
      </span>
    </div>
    <div>
      <span class="priceItem" style="margin-right: 20px">
        <span class="label">应付金额：</span>
        <span class="price" style="color: #ff2f2f">￥{{ activityMoney }}</span>
      </span>
      <el-button
        style="width: 80px"
        type="warning"
        size="small"
        plain
        @click="openDiscountCard"
        >优惠券</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        size="small"
        plain
        @click="openBeizhu"
        >备注</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        size="small"
        @click="drawerDingjinOrderList_state = true"
        >结算</el-button
      >
    </div>
    <!-- 备注弹窗 -->
    <div v-if="drawerRemark_state">
      <drawerRemark
        :type="'livingUpdate'"
        @submit="submit_drawerRemark"
      ></drawerRemark>
    </div>
    <!-- 结算 -->
    <div v-if="dialogSettlement_state">
      <dialogSettlement
        :type="orderPayType"
        :canYue="false"
        :orderId="curOrder.no"
        @submit="submit_dialogSettlement"
      ></dialogSettlement>
    </div>
    <!-- 优惠券 -->
    <div v-show="drawerDiscountCard_state">
      <drawerDiscountCard
        :userId="userInfo._id"
        :type="8"
        :state="drawerDiscountCard_state"
        :money="money"
        @submit="submit_drawerDiscountCard"
      ></drawerDiscountCard>
    </div>
    <div v-if="drawerDingjinOrderList_state">
      <drawerDingjinOrderList
        :petId="dingjinOrder.order_item_list[0].goods_id"
        :type="'selected'"
        @submit="submit_drawerDingjinOrderList"
      ></drawerDingjinOrderList>
    </div>
  </div>
</template>
<script>
import drawerDiscountCard from "../drawer/discountCard.vue";
import drawerRemark from "../drawer/remark.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
import del from "../../../../util/del.js";
import drawerDingjinOrderList from "../drawer/dingjinOrderList.vue";
export default {
  components: {
    drawerDiscountCard,
    drawerRemark,
    dialogSettlement,
    drawerDingjinOrderList,
  },
  data() {
    return {
      // 备注
      drawerRemark_state: false,
      // 结算
      dialogSettlement_state: false,
      curOrder: {},
      //
      o: null,
      serviceList: [],
      // 优惠券
      drawerDiscountCard_state: false,
      // 是否直接结算
      direct: true,
      // 订金订单列表
      drawerDingjinOrderList_state: false,
      orderPayType:'tailMoney'
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    pet_buy_item() {
			return this.$store.state.livingUpdate.pet_buy_item;
		},
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    curDiscountCard() {
      return this.$store.state.livingUpdate.curDiscountCard;
    },
    addParams() {
      return this.$store.state.livingUpdate.addParams;
    },
    money() {
      return this.$store.state.livingUpdate.money;
    },
    activityMoney() {
      return this.$store.state.livingUpdate.activityMoney;
    },
    remark() {
      return this.$store.state.livingUpdate.remark;
    },
    dingjinOrder() {
      return this.$store.state.livingUpdate.dingjinOrder;
    },
  },
  mounted() {
    this.o = new del();
    console.log(this.dingjinOrder);
  },
  methods: {
    // submitOrderAndSettlement(){
    // 	this.direct = true;
    // 	this.submitOrder();
    // },
    // 创建订单
    submitOrder(selectedDingjinOrderList) {
      if (this.userInfo._id === "sankeId") {
        this.$message({
          message: "散客不能购买宠物",
          type: "error",
        });
      }
      if (
        this.$public.isNull(this.addParams.curItem) ||
        this.$public.isNull(this.addParams.curItem._id)
      ) {
        this.$message({
          message: "请选择要购买的宠物",
          type: "error",
        });
        return;
      }
      // let salesMans = []
      // let saleList=this.dingjinOrder.order_item_list[0].sales_list;
      // for(let i=0;i<saleList.length;i++){
      // 	salesMans.push({"userId": saleList[i].sales_id,"userName": saleList[i].sales_name})
      // }
      if (this.$public.isNull(this.addParams.saleManIdList)) {
        this.$message({
          message: "请选择活体销售人员",
          type: "error",
        });
        return;
      }
      let salesMans = [];
      let aaa = this.addParams.saleManIdList.split(",");
      salesMans.push({ userId: aaa[0], userName: aaa[1] });
      // for(let i=0;i<this.addParams.saleManIdList.length;i++){
      // 	let arr = this.addParams.saleManIdList[i].split(',')
      // 	salesMans.push({"userId": arr[0],"userName": arr[1]})
      // }

      let arr = [];
      if (this.addParams.giftTableData) {
        for (let i = 0; i < this.addParams.giftTableData.length; i++) {
          let goods = this.addParams.giftTableData[i];
          if (goods.num === 0) continue;
          console.log(goods, "goods.goodsList[a]");
          let one = {
            goodsId: goods.goodsId,
            goodsName: goods.goodsName,
            goodsType: goods.goodsType,
            brand: "",
            categoryId: goods.category_info._id,
            categoryName: goods.category_info.name,
            petId: "",
            petName: "",
            skus: goods.skus,
            skuValue: goods.skuValue,
            unitId: goods.unitId,
            unit: goods.unit,
            originalPrice: goods.originalPrice,
            price: goods.price,
            num: goods.num,
            activityId: "",
            activityName: "",
            goodsList: [],
            salesMans: salesMans,
            goodsSalesModel: 1, // 商品销售模式 1：正常销售；2：赠品
          };
          for (let a = 0; a < goods.goodsList.length; a++) {
            one.goodsList.push({
              goodsId: goods.goodsList[a].goodsId,
              goodsName: goods.goodsList[a].goodsName,
              customBarCode: goods.goodsList[a].customCode, // 条码
              price: goods.goodsList[a].price,
              costPrice: goods.goodsList[a].costPrice,
              skus: goods.goodsList[a].skus,
              skuValue: goods.goodsList[a].skuValue,
              model: goods.goodsList[a].skuValue,
              unitId: goods.goodsList[a].unitId,
              unit: goods.goodsList[a].unit,
              expiryDate: goods.goodsList[a].validityStopDate,
              isOut: false,
              outDosage: 0,
              outUnit: "",
              goodsSalesModel: 1,
            });
          }
          arr.push(one);
        }
      }
      let goods = this.addParams.curItem.product;
      let one = {
        goodsId: goods.pet_id, // 销售对象id
        goodsName: goods.inside_name, // 销售对象名字
        goodsType: 5, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
        brand: "",
        categoryId: goods.category_info._id,
        categoryName: goods.category_info.name,
        petId: "",
        petName: "",
        skus: "",
        skuValue: goods.inside_no,
        unitId: "",
        unit: "",
        originalPrice: this.money,
        price: this.activityMoney,
        num: 1,
        activityId: goods.special_type==1? '1': this.addParams.activityId||'',
        activityName: goods.special_type==1? '特价':this.addParams.activityId?this.addParams.activityItem.name:'',
        payType: this.addParams.activityIds
          ? this.addParams.activityItem.pay_type
          : "",
        salesMans: salesMans,
        barCode: goods.eprom_no, // 条码
        goodsSalesModel: 0, // 商品销售模式 1：正常销售；2：赠品
      };
   
      let earnestsOrderNos = [];
      for (let i = 0; i < selectedDingjinOrderList.length; i++) {
        earnestsOrderNos.push(selectedDingjinOrderList[i].no);
      }
      console.log(one, "one", arr);
      let params = {
        memberId: this.userInfo._id,
        memberName: this.userInfo.basic_info.nick_name,
        memberMobile: this.userInfo.basic_info.user_mobile,
        remark: this.remark, // 订单备注
        coupon_no: this.$public.isNull(this.curDiscountCard)
          ? ""
          : this.curDiscountCard._no,
        earnestsOrderNos: earnestsOrderNos,
        orderGoods: [one].concat(arr),
        "sale_pet_info":[],
        "pet_buy_item": Number(this.pet_buy_item)
						}
				params.sale_pet_info.push(goods.pet_sex,goods.pet_age,String(goods.create_day))
				console.log(params.sale_pet_info,params)
      console.log(params);
      let loading = this.$loading();
      this.$http
        .post("/api/Order/CreateLivingBalanceOrder", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            if (this.direct) {
              this.curOrder = res.data;
              if (this.pet_buy_item == 2) {
							this.orderPayType = 'tailMoneyMergeOrder'
							this.curOrder.no = res.data.merge_order_no
						}else{
							this.orderPayType = 'tailMoney'
						}
              this.dialogSettlement_state = true;
            } else {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$store.dispatch("mendian/get_unPayOrderList");
              this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
              this.$store.commit("livingUpdate/set_refresh");
            }
          }
        });
    },
    // 优惠券
    openDiscountCard() {
      if (this.$public.isNull(this.addParams.activityId)) {
        this.drawerDiscountCard_state = true;
      } else {
        this.$message({
          message: "参与活动后不可使用优惠券",
          type: "error",
        });
      }
    },
    submit_drawerDiscountCard(obj) {
      if (obj.type === "submit") {
        this.$store.commit("livingUpdate/set_activityMoney", obj.newMoney);
        this.$store.commit("livingUpdate/set_curDiscountCard", obj.card);
        this.drawerDiscountCard_state = false;
      } else {
        this.drawerDiscountCard_state = false;
      }
    },
    delDiscountCard() {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("livingUpdate/set_curDiscountCard", null);
      });
    },
    // 结算
    submit_dialogSettlement(a) {
      this.dialogSettlement_state = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
      }
      this.$store.commit("mendian/set_curBusiness", "活体");
      this.$store.commit("living/set_type", "dingList");
      this.$store.commit("living/set_refresh");
    },
    // 备注
    openBeizhu() {
      this.drawerRemark_state = true;
    },
    submit_drawerRemark() {
      this.drawerRemark_state = false;
    },
    // 订金列表弹窗
    submit_drawerDingjinOrderList(obj) {
      this.drawerDingjinOrderList_state = false;
      if (obj.type === "success") {
        console.log(obj);
        if (obj.data.length === 0) {
          this.$message({
            message: "请选择订金订单",
            type: "error",
          });
          return;
        } else {
          this.submitOrder(obj.data);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.panel_settlement {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 -3px 3px 0px #f5f5f5;
  .priceItem {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
    .label {
      font-size: 14px;
      color: $fontColor;
    }
    .price {
      font-size: 20px;
      color: $fontColor;
    }
  }
}
</style>
